import { useEffect, useState } from 'react';

import { Field, ErrorMessage, useFormikContext } from 'formik';

import { api, useAPIContext } from '../../api/context';
import toast from '../../utils/toast';

const PostCode = ({ loading }) => {

  const { token } = useAPIContext();
  const [ _loading, _setLoading ] = useState(true);

  const DEFAULT = 'Post Code';
  const [ label, setLabel ] = useState(DEFAULT);

  const { values: { country }, setFieldValue } = useFormikContext();

  useEffect(() => {

    _setLoading(true);

    if (!country) {
      setLabel(DEFAULT);
      setFieldValue('post_code', '');
      return;
    }

    api(token).v1.profile.countries.obtain({ country })
      .then(res => {
        if (res.status === 200) {
          _setLoading(false);
          setLabel(res.body.labels.post_code);
        }
      })
      .catch(err => {
        toast.show(toast.KIND.WARNING, err);
      });

  }, [country, setFieldValue, token]);

  const validate = (value) => {

    return new Promise((resolve, reject) => {

      if (!value) {
        resolve();
        return;
      }

      _setLoading(true);

      api(token).v1.profile.countries.postcode
        .query({ country }, { value })
        .then(res => {
          _setLoading(false);

          if (res.status === 404) {
            resolve();
          }

          if (res.status === 200) {
            if (res.body.match) {
              const valid = res.body.value;
              if (value !== valid) {
                setFieldValue('post_code', valid);
              }
              resolve();
            } else {
              resolve(res.body.error);
            }
          }
        })
        .catch(err => {
          _setLoading(false);
          toast.show(toast.KIND.WARNING, err);
          reject(err);
        });

    });
  };

  return (
    <div>
      <label htmlFor='post_code'>{label}</label>

      <Field
        id='post_code'
        aria-label={label.toLowerCase()}
        name='post_code'
        type='text'
        disabled={loading || _loading}
        validate={validate}
      />

      <ErrorMessage
        name='post_code'
        component='div'
      />
    </div>
  );
};

export default PostCode;